import { createOptions } from 'options';
import { budgetScopes, feeAffinities } from '../plan/types';
import { createSelectField } from 'components';

export const budgetScopeOptions = createOptions(budgetScopes, {
  TOTAL: 'Total (media + services + fees)',
  MEDIA_EXCL_FEE: 'Media excluding fees',
  MEDIA_INCL_FEE: 'Media including fees',
});

export const feeAffinityOptions = createOptions(feeAffinities, {
  IMPLICIT: 'On target row',
  EXPLICIT: 'On its own',
});

export const BudgetScopeField = createSelectField(budgetScopeOptions, {
  simple: true,
  help: 'Defines what row items count toward the budget.',
});
export const FeeAffinityField = createSelectField(feeAffinityOptions, {
  simple: true,
  help: 'Controls how smart fee budget is distributed.',
});
